module.exports = __webpack_public_path__ + "img/9788954608138.8fff96d2.jpg";